export default (_from, _to, _step, block) => {
  _from = Number(_from);
  _to = Number(_to);
  _step = Number(_step);

  if (_step === 0) {
    throw 'Looping has zero step value';
  }

  let accum = '';
  let v = _from;

  const canLoop = () => {
    return _step < 0 ? v >= _to : v <= _to;
  };

  while (canLoop()) {
    accum += block.fn(v);
    v += _step;
  }

  return accum;
};